import "../locales";
import * as React from "react";
import { PostHogProvider } from "posthog-js/react";
import { Outlet } from "react-router-dom";
import { useUserSlice } from "@/models/useUserSlice";
import AlertPromptSignIn from "@/ui/AlertPromptSignIn";
import AlertModal from "@/ui/AlertModal";
import { useToast } from "@/models/useToast";
import AlertPrompt from "@/ui/AlertPrompt";
import AlertSelect from "@/ui/AlertSelect";
import AlertWidgetPaywall from "@/ui/AlertWidgetPaywall";
import AlertAIEdits from "@/ui/AlertAIEdits";
import AlertOnboarding from "@/ui/AlertOnboarding";

const HelmetProvider = React.lazy(() =>
  import("react-helmet-async").then((m) => ({ default: m.HelmetProvider }))
);

const GoogleOAuthProvider = React.lazy(() =>
  import("@react-oauth/google").then((m) => ({
    default: m.GoogleOAuthProvider,
  }))
);

// Lazy load analytics
const loadAnalytics = () => {
  import("@/fetchData/gtag").then((gtag) => {
    gtag.pageview(window.location.pathname);
  });
  import("@/fetchData/fpixel").then((fbq) => {
    fbq.pageview();
  });
  import("@/fetchData/datadog");
};

export default function MyApp() {
  const _hydrated = useUserSlice((state) => state._hasHydrated);
  const { ToastContainer } = useToast();

  React.useEffect(() => {
    loadAnalytics();

    const handlePopState = () => {
      loadAnalytics();
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  if (!_hydrated) {
    return null;
  }

  return (
    <React.Suspense>
      <HelmetProvider>
        <PostHogProvider
          apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
          options={{
            api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
            // disable_session_recording: true,
          }}
        >
          <GoogleOAuthProvider
            clientId={import.meta.env.VITE_PUBLIC_GOOGLE_CLIENT_ID}
          >
            <AlertOnboarding />
            <Outlet />
            <AlertAIEdits />
            <AlertModal />
            <AlertPrompt />
            <ToastContainer />
            <AlertSelect />
            <AlertWidgetPaywall />
            <AlertPromptSignIn />
          </GoogleOAuthProvider>
        </PostHogProvider>
      </HelmetProvider>
    </React.Suspense>
  );
}
